import { render, staticRenderFns } from "./m-input.vue?vue&type=template&id=128f551c&scoped=true"
import script from "./m-input.vue?vue&type=script&lang=js"
export * from "./m-input.vue?vue&type=script&lang=js"
import style0 from "./m-input.vue?vue&type=style&index=0&id=128f551c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128f551c",
  null
  
)

export default component.exports